<script setup>
import { storeToRefs } from 'pinia'

import { TextField } from '@haskoning/vue-component-library'

import { useOptimisationStore } from '@/stores/optimisation'

const props = defineProps({
  field: { type: String, required: true }
})

const optimisationStore = useOptimisationStore()

const { currentItem, fields } = storeToRefs(optimisationStore)
</script>

<template>
  <TextField
    :item-key="field"
    :field="fields[field]"
    :model-value="currentItem"
    :show-fraction-digits="true"
    class="text-field"
    density="compact"
    variant="plain"
    no-label
    hide-details
    @update="optimisationStore.update(currentItem)"
  >
  </TextField>
</template>

<style scoped>
.text-field :deep(.v-field__input) {
  text-align: center;
}
</style>
